var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframe)?_c('div',{staticClass:"c-block-list-iframe",attrs:{"id":("block-" + (_vm.$vnode.key))}},[(_vm.title)?_c('LongReadTarget',{staticClass:"relative mb-2xs/v",attrs:{"container-id":("block-" + (_vm.$vnode.key)),"link-to-toc":{
			name: ("Spring til \"" + _vm.title + "\" i indholdsfortegnelsen"),
			attrs: {
				'data-focus-ignore': true,
			},
		},"title":_vm.title,"disabled":!_vm.showTitleInToc}},[_c('BaseH2',{domProps:{"innerHTML":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),_c('CookieInformationBlocker',{attrs:{"categories":[
				_vm.statistic && 'statistic',
				_vm.functional && 'functional',
				_vm.marketing && 'marketing' ].filter(Boolean)}},[_c('PostScribeScript',{staticClass:"c-block-list-iframe__embed",attrs:{"html":_vm.iframe}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }